import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';

const tryToFetchFeedbacks = (
  pageNumber: number,
  pageSize: number,
  data?: any,
  filters?: string,
): Promise<AxiosResponse<any>> => {
  const url = filters
    ? `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedback-details?page=${pageNumber}&size=${pageSize}&search=${filters}`
    : `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedback-details?page=${pageNumber}&size=${pageSize}`;

  const requestBody = {
    ...data,
    platform: 'web-dashboard'
  };

  return deviceInfoAxios.put<any>(url, requestBody);
};

/** ✅ NEW: update feedback importance (Admin only) */
const tryToUpdateFeedbackImportance = (
  id: string,
  payload: {
    importance: 'High' | 'Medium' | 'Low';
    originalImportance?: 'High' | 'Medium' | 'Low';
  },
): Promise<AxiosResponse<any>> => {
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedbacks/${id}/importance`;
  return deviceInfoAxios.put<any>(url, payload);
};

const tryToFetchAllFeedbacks = (data: any): Promise<AxiosResponse<any>> => {
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedback-details/download`;
  return deviceInfoAxios.put(url, data);
};

export type UpdateFeedbackCategoryPayload = {
  category: string | null;
  subCategory: string | null;
};

const tryToUpdateFeedbackCategory = (
  id: string,
  payload: UpdateFeedbackCategoryPayload,
): Promise<AxiosResponse<any>> => {
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/${id}/category`;
  return deviceInfoAxios.patch<any>(url, payload);
};

/** PATCH /rebecca-ai-agent/feedbacks/:id — update any editable field */
const tryToUpdateFeedback = (
  id: string,
  payload: Record<string, any>,
): Promise<AxiosResponse<any>> => {
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedbacks/${id}`;
  return deviceInfoAxios.patch<any>(url, payload);
};

export const AdminFeedbacksService = {
  tryToFetchFeedbacks,
  tryToFetchAllFeedbacks,
  tryToUpdateFeedbackCategory,
  tryToUpdateFeedbackImportance,
  tryToUpdateFeedback,
};
